// RC8 · One shared read-time enrichment for every briefing surface
// (dedicated reader + landing panel): locked guide indexes for links,
// and the voyage's port-day weather. All fetches are silent best-effort;
// nothing here changes briefing documents.

import React from "react";
import { resolveItemEnrichment } from "./briefingEnrichment";

const API = process.env.REACT_APP_BACKEND_URL;

async function getJson(url) {
  try {
    const r = await fetch(url, { credentials: "include" });
    if (!r.ok) return null;
    return await r.json();
  } catch {
    return null;
  }
}

export function useBriefingEnrichment(selectedCruiseId) {
  const [guides, setGuides] = React.useState([]);
  const [seaDayGuides, setSeaDayGuides] = React.useState([]);
  const [weather, setWeather] = React.useState({});

  React.useEffect(() => {
    let live = true;
    const vParam = selectedCruiseId ? `?voyage_id=${encodeURIComponent(selectedCruiseId)}` : "";
    (async () => {
      const [g, s, w] = await Promise.all([
        getJson(`${API}/api/knowledge/destination-guides`),
        selectedCruiseId
          ? getJson(`${API}/api/knowledge/sea-day-guides?cruise_id=${encodeURIComponent(selectedCruiseId)}`)
          : null,
        getJson(`${API}/api/cruises/current/port-weather${vParam}`),
      ]);
      if (!live) return;
      if (Array.isArray(g?.guides)) setGuides(g.guides);
      if (Array.isArray(s?.guides)) setSeaDayGuides(s.guides);
      if (Array.isArray(w?.ports)) {
        const byPort = {};
        w.ports.forEach((p) => { if (p.port_id && !byPort[p.port_id]) byPort[p.port_id] = p; });
        setWeather(byPort);
      }
    })();
    return () => { live = false; };
  }, [selectedCruiseId]);

  return React.useCallback((item) => {
    const e = resolveItemEnrichment(item, { guides, seaDayGuides });
    if (!e) return null;
    const portId = e.media?.type === "port" ? e.media.id : null;
    return { ...e, weather: portId ? weather[portId] || null : null };
  }, [guides, seaDayGuides, weather]);
}
